import { CvCompetenceTypes } from "./cv-competence-types.component";
import { CvCompetenceType } from "./cv-competence-type.component";
import { EditCvCompetenceType } from "./cv-competence-type.edit.component";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIRouterModule } from "@uirouter/angular";
import { cvCompetenceTypesState, cvCompetenceTypeState, newCvCompetenceTypeState, editCvCompetenceTypeState } from "./cv-competence-types.states";
import { AllMaterialModule } from "../../all-material.components";
import { FlexLayoutModule } from "@angular/flex-layout";

import SharedModule from "../../shared/shared.module";
import { CoreModule } from "../../core/core.module";

let CV_COMPETENCE_TYPE_STATES = [cvCompetenceTypesState, cvCompetenceTypeState, newCvCompetenceTypeState, editCvCompetenceTypeState];

import { ConfirmDialog } from "../../shared/confirm-dialog.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AllMaterialModule,
        SharedModule,
        CoreModule,
        FlexLayoutModule,
        UIRouterModule.forChild({ states: CV_COMPETENCE_TYPE_STATES })
    ],
    declarations: [CvCompetenceTypes, CvCompetenceType, EditCvCompetenceType],
    entryComponents: [ConfirmDialog]
})
export class CvCompetenceTypesModule {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/cvcompetencetypes/cv-competence-types.module.ts